import { privateAxios } from "@/common/api/axios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseClientCompanyPaymentMethodsProps<T> = {
  filters?: {
    search?: string
    page?: number
  }
  mapper?: (data: any) => T
}

export const useClientCompanyPaymentMethods = <T,>({
  filters: { search, page } = {},
  mapper = Mapper.default<T>(),
}: UseClientCompanyPaymentMethodsProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['clientCompanyPaymentMethods', search, page],
    queryFn: () => {
      return privateAxios.get(`/companies/payment_methods`, {
        params: {
          search,
          page,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
